import React from 'react'
import {
  Router, Route, Switch, Redirect,
} from 'react-router-dom'
import { ApolloProvider, Query } from 'react-apollo'
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks'
import { Loading, H3, Div } from 'konsys-ui'
import client from './apollo-client'
import history from './history'
import HomePage from './pages/home'
import LandingPage from './pages/landing'
import FillingOrderPage from './pages/filling-order-qr-code-page'
import GasstationReport from './pages/gasstation-report-page'
import FillingOrderListPage from './pages/filling-order-page/list'
import Login from './pages/login'
import NotificationPage from './pages/notification-page'
import { ForgotPasswordSection, ResetSection } from './components/login/reset-password'
import NotFound from './pages/not-found'
import { MainContainer } from './components/container'
import { GET_PERMS } from './constants/graphql/query'
import filteringMenu from './utils/route-handler'
import Menu from './components/menu'
import { getAccessToken } from './utils/local-data-service'

history.listen(() => {
  window.scrollTo(0, 0)
})

const Center = ({ children }) => (
  <Div display='flex' justifyContent='center' alignItems='center' width='100vw' height='100vh'>{children}</Div>
)

const App = () => (
  <ApolloProvider client={client}>
    <ApolloHooksProvider client={client}>
    <Router history={history}>
      {
        !getAccessToken()
          ? <Switch>
              <Route path='/' exact component={LandingPage}/>
              <Route path='/login' exact component={Login}/>
              <Route path='/forgot-password' exact component={ForgotPasswordSection}/>
              <Route path='/reset-password/:token' exact component={ResetSection}/>
              <Redirect to={Login}/>
            </Switch>
          : <Query
              query={GET_PERMS}
            >{({ data, loading, error }) => {
              if (loading) return <Center><Loading size='large'/></Center>
              if (error) return <Center><H3>เกิดข้อผิดพลาด</H3></Center>
              const menuKeys = data.MyPerm.data.menu.map(i => i.key)
              const permKeys = data.MyPerm.data.perms.map(i => i.name)
              const filteredByPermissionMenu = filteringMenu(menuKeys, permKeys)
              window.perms = permKeys
              window.role = data.MyPerm.myRole
              if (data.MyPerm.myRole !== 'FuelFiller') {
                return (
                  <MainContainer>
                    <Menu menu={menuKeys}>
                      <Switch>
                        <Route path='/' exact component={LandingPage}/>
                        <Route path='/home' exact component={HomePage}/>
                        {/* <Route path='/dashboard' exact component={Dashboard}/> */}
                        <Route path='/notification' exact component={NotificationPage}/>
                        <Route path='/filling-record/:fillingOrderId' exact component={FillingOrderPage}/>
                        {
                          filteredByPermissionMenu.map(v => v.component)
                        }
                        <Route component={NotFound}/>
                      </Switch>
                    </Menu>
                  </MainContainer>
                )
              } return (
                <MainContainer>
                  <Menu menu={menuKeys}>
                    <Switch>
                      <Route path='/home' exact component={HomePage}/>
                      <Route path='/fill-order' exact component={FillingOrderListPage}/>
                      <Route path='/filling-record/:fillingOrderId' exact component={FillingOrderPage}/>
                      <Route path='/gasstation-report' exact component={GasstationReport}/>
                      <Route component={NotFound}/>
                    </Switch>
                  </Menu>
                </MainContainer>
              )
            }}
            </Query>
      }
    </Router>
    </ApolloHooksProvider>
  </ApolloProvider>
)

export default App
